

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductDto, ProductsBlockDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
import HeadingBlock from '@/views/cms/simple/HeadingBlock.vue';
import { ProductTuple } from '@/stores/search/util';
import ProductGrid from '@/views/product/ProductGrid.vue';

@Component({
  components: {ProductGrid, HeadingBlock, CmsLink},
})
export default class ProductsBlock extends Vue {
  @Prop({required: true})
  public readonly model!: ProductsBlockDto;

  public currentPageIndex: number = 0;

  public get hasTeaserLink(): boolean {
    return this.hasTeaser && !!this.model.teaserLink;
  }

  public get hasTeaser(): boolean {
    return !!this.model.teaserImagePath;
  }

  public get pageSize(): number {
    const teaserPenalty = this.hasTeaser ? 1 : 0;
    if (this.$mq.desktop) {
      return 5 - teaserPenalty;
    } else if (this.$mq.tabletOrMore) {
      return 4 - teaserPenalty;
    } else {
      return 1;
    }
  }

  public get pageCount(): number {
    if (this.pageSize <= 1) {
      return 1;
    } else {
      return Math.ceil(this.model.products.length / this.pageSize);
    }
  }

  public get currentPage(): ProductTuple[] {
    if (this.pageSize <= 1) {
      return this.model.products
        .map((product) => this.toTuple(product));
    }
    const firstProduct = this.currentPageIndex * this.pageSize;
    return this.model.products
      .slice(firstProduct, firstProduct + this.pageSize)
      .map((product) => this.toTuple(product));
  }

  public get hasPreviousPage(): boolean {
    return this.currentPageIndex > 0;
  }

  public get hasNextPage(): boolean {
    return this.currentPageIndex < (this.pageCount - 1);
  }

  public goBack(): void {
    if (this.hasPreviousPage) {
      this.currentPageIndex -= 1;
    }
  }

  public goForwards(): void {
    if (this.hasNextPage) {
      this.currentPageIndex += 1;
    }
  }

  private toTuple(product: ProductDto): ProductTuple {
    const unit = product.units.units.find((u) => u.abbreviation === product.units.defaultUnit)
      ?? product.units.units.find((u) => u.abbreviation === product.units.storageUnit)
      ?? product.units.units[0];
    return {product, unit};
  }
}
